export const isStorybook = process.env.STORYBOOK === "true"
